// App version management
// Update this value before each release
export const APP_VERSION = '1.4.56';

// Build number injected at build time by Vite define, or fallback to 0
export const BUILD_NUMBER: number = (globalThis as any).__BUILD_NUMBER__ ?? 0;

// Injected at build time by Vite define
export const BUILD_TIME: string = (globalThis as any).__BUILD_TIME__ ?? new Date().toISOString();

export const getVersionDisplay = () => `v${APP_VERSION}`;
